import { combineReducers } from 'redux';

import form from './form';
import modal from './modal';

const combined = combineReducers({
  form,
  modal,
});

const rootReducer = (state, action) => combined(state, action);

export { form, modal };
export default rootReducer;
